import React from 'react'
import CheckInBaggageFilter from './CheckInBaggageFilter'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'

const showBaggage = (fareInclusions: any) =>
  !!fareInclusions?.options?.some((option: any) => option.value == 'withBaggage')

const isApplied = (inclusions: any) => inclusions?.selectedValues?.includes('withBaggage')

const CheckInBaggageFilterNew = ({
  onFilterChange,
  fareInclusions,
  returnFareInclusions,
  isRT,
  processedData,
  clearFiltersCategoryWise,
  selectedFilters,
  isRevamp = false,
}: {
  onFilterChange: any
  fareInclusions: any
  returnFareInclusions: any
  isRT: boolean
  processedData: any
  clearFiltersCategoryWise: any
  selectedFilters: any
  isRevamp?: boolean
}) => {
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, 'checkInBaggage')
  const showBothLegs = isRT && showBaggage(returnFareInclusions)
  const count = Number(!!isApplied(fareInclusions)) + Number(!!isApplied(returnFareInclusions))
  const shared = { isRT, isRevamp, onFilterChange }

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Baggage' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {showBaggage(fareInclusions) && (
          <CheckInBaggageFilter
            {...shared}
            fareInclusions={fareInclusions}
            from={processedData?.source}
            to={processedData?.destination}
            legIsOnward
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />

        {showBothLegs && (
          <CheckInBaggageFilter
            {...shared}
            fareInclusions={returnFareInclusions}
            from={processedData?.destination}
            to={processedData?.source}
            legIsOnward={false}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default CheckInBaggageFilterNew
